import Service from '@/service/index.js';
export default {
  components: {
  },
  props: ['type'],
  data() {
    return {
      managementSubjectCodeArr: [],
      transferTypeArr: [],
      payTypeArr: [],
      circulationTypeCodeArr: []
    };
  },
  created() {
    const obj = {
      MANAGEMENT_SUBJECT: 'managementSubjectCodeArr',
      TRANSFER_TYPE: 'transferTypeArr',
      PAY_TYPE: 'payTypeArr',
      CIRCULATION_TYPE: 'circulationTypeCodeArr'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  computed: {
  },
  methods: {
  }
};
